import { useContext, useEffect, useRef, useState } from 'react';
import { PhoenixSocketContext } from '../context';

import type { Channel } from 'phoenix';

export const useChannel = (channelName: string) => {
  const [channel, setChannel] = useState<Channel | undefined>(undefined);
  const { socket } = useContext(PhoenixSocketContext);
  const initialChannelName = useRef(channelName);

  useEffect(() => {
    if (channelName !== initialChannelName.current) {
      return;
    }

    const phoenixChannel = socket?.channel(channelName);

    phoenixChannel
      ?.join()
      .receive('ok', () => {
        setChannel(phoenixChannel);
      })
      .receive('error', (resp) => {
        console.error('Failed to join channel:', resp);
      });

    return () => {
      phoenixChannel?.leave();
    };
  }, [channelName, socket]);

  return [channel];
};
